// Function to handle variant change logic
function handleVariantChange(variantId) {
    console.log('handleVariantChange', variantId);
    if(document.querySelectorAll('.PreOrder_custom').length > 0){
        const variantDropdownSelected = document.querySelector('select.product_variant_select option[value="'+variantId+'"]');
        const preOrderProperty = document.querySelector('.preorderProperty');
        
        if (!variantDropdownSelected || !preOrderProperty) return;
        
        var variant_qty  = variantDropdownSelected.dataset.qty;
        var variant_avail= variantDropdownSelected.dataset.avail;
        var dataPurchaseAction = preOrderProperty.dataset.purchaseTypeAction;
        
        if(variant_qty <= 0 && variant_avail == 'true'){
            document.querySelector('.PreOrder_custom').textContent = dataPurchaseAction;
            preOrderProperty.innerHTML=`<input id="preorder-product" type="hidden" value="${dataPurchaseAction}" name="properties[This is a]"/>`;
        }
        else{
            preOrderProperty.innerHTML='';
        }
    }
}

// Watch for changes to the hidden input[name="id"] field
document.addEventListener('DOMContentLoaded', function() {
    const variantInput = document.querySelector('input[name="id"]');
    
    if (variantInput) {
        // Use MutationObserver to watch for attribute changes
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    const variantId = variantInput.value;
                    if (variantId) {
                        handleVariantChange(variantId);
                    }
                }
            });
        });
        
        observer.observe(variantInput, {
            attributes: true,
            attributeFilter: ['value']
        });
        
        // Also listen for direct input changes
        variantInput.addEventListener('change', function() {
            const variantId = this.value;
            if (variantId) {
                handleVariantChange(variantId);
            }
        });
    }
});

var modal = document.getElementById("madeToOrderModal");
var openBtn = document.getElementById("madeToOrderBtn");
var closeBtn = document.getElementById("closeModal");
var readyDateEl = document.getElementById("readyDate");

function getReadyDate() {
    var today = new Date();
    today.setDate(today.getDate() + 14);
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return today.toLocaleDateString(undefined, options);
}

if (readyDateEl) {
    readyDateEl.textContent = getReadyDate();
}

if (openBtn && modal && closeBtn) {
    openBtn.addEventListener("click", function(e) {
    e.preventDefault();
    modal.style.display = "block";
    });

    closeBtn.addEventListener("click", function() {
    modal.style.display = "none";
    });

    window.addEventListener("click", function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
    });
}